export default __webpack_public_path__ + "static/media/balance-wellness-convert.d4123df1.md";